import Storage from "@/app/core/util/Storage";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";

export default function AllTerms(props) {
    const userData = Storage.getUserData();
    const [data, setData] = useState([]);
    const [lessons, setLessons] = useState();
    const [correctAnswers, setCorrectAnswers] = useState();
    const [terms, setTerms] = useState([
        {
            name: "Política de privacidade",
            id: 0,
            uri: "",
            url: "https://google.com",
            updatedDate: "",
            createdDate: "",
        },
        {
            name: "Termos de uso",
            uri: "",
            id: 1,
            url: "https://google.com",
            updatedDate: "",
            createdDate: "",
        },
    ]);

    useEffect(() => {
        loadPresentation()
    }, []);

    function loadPresentation() {
        // if(userData != null){
        //     setData([
        //         {
        //             id: 0,
        //             userId: "",
        //             term: {
        //                 name: "Política de privacidade",
        //                 uri: "",
        //                 url: "https://google.com",
        //                 updatedDate: "",
        //                 createdDate: "",
        //             },
        //             updatedDate: "",
        //             createdDate: "",

        //         },
        //         {
        //             id: 1,
        //             userId: "",
        //             term: {
        //                 name: "Termos de uso",
        //                 uri: "",
        //                 url: "https://google.com",
        //                 updatedDate: "",
        //                 createdDate: "",
        //             },
        //             updatedDate: "",
        //             createdDate: "",

        //         },
        //         {
        //             id: 2,
        //             userId: "",
        //             term: {
        //                 name: "Política de cancelamento",
        //                 uri: "",
        //                 url: "https://google.com",
        //                 updatedDate: "",
        //                 createdDate: "",
        //             },
        //             updatedDate: "",
        //             createdDate: "",

        //         }])
        // }

        let items = []
        for (let s in lessons) {
            let item = lessons[s];
            const answers = correctAnswers.filter(x => x.LessonId == item.Id);
            item.answers = answers;
            items.push(item);
        }

        setData(items);
    }

    function openLink(item) {
        registerConversion(item)
        window.open(item.url, "_blank");
    }

    function registerConversion() { }


    async function handleChange(checked, item, index) {
        // CustomerResponseTerms(item.id, checked, (res) => loadConfigurations());
        let old = data;
        old[index].response = checked;
        setData(old);
    }

    function termsOfComparation(correct) {
        switch (correct) {
            case "isn’t":
                return "is not";
            case "arent ":
                return "are not";
            // case "aren’t ":
            //     return "are not";

            default:
                break;
        }
    }

    return (
        <div className="content row mt-3">
            <div className="col-md-12">
                <h3 className="text-muted"><i className="fa fa-arrow-left mr-1" /> Termos de uso & políticas de privacidade</h3>
            </div>

            {/* {data && data.map((item, index) => (
                <div className="col-md-12">
                    <div className="block block-bordered block-content">
                        <div className="form-group">
                            <div className="custom-control custom-checkbox custom-control-primary">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id={`check-${item.id}`}
                                    name={`check-${item.id}`}
                                    checked={item.response}
                                    onChange={(evt) =>
                                        handleChange(evt.target.checked, item, index)
                                    }
                                />
                                <label
                                    className="custom-control-label"
                                    for={`check-${item.id}`}
                                >
                                    Eu concordo com{" "}
                                    <a href={item.term.url} target="_blank">
                                        {item.term && item.term.name}
                                    </a>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            ))} */}

            {data && data.map((item, index) => (
                <div className="block">
                    <div className="block-header">Hint: {item.Hint} - Resposta: {item.Answer} - ID: {item.Id}</div>
                    {`INSERT INTO CorrectAnswers (LessonId, Value, CreatedDate, UpdatedDate) VALUES ( ${item.Id}, '${termsOfComparation(item.Answer)}', '2024-03-25 22:04', '2024-03-25 22:04');`}
                    <ul>
                        {item && item.answers && item.answers.map(answer => (
                            <li>{answer.Value}</li>
                        ))}

                    </ul>
                </div>
            ))}


            {userData == null ?
                <div className="block col-md-12 block-content">
                    {terms && terms.map(item => (
                        <div className="block block-bordered block-content">
                            <div className="form-group">
                                <div className="custom-control custom-checkbox custom-control-primary">
                                    <a href={item.url} target="_blank">
                                        {item && item.name}
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                : ""}
        </div>
    )
}